import { get } from 'lodash'
import React from 'react'
import { Form } from 'react-bootstrap'
import moment from 'moment'

export default ({ userReflection = {} }) => {
    const date = get(userReflection, 'reflection.createdDate')
    if (!date) {
        return null
    }
    const label = moment(date).format('dddd, MMMM Do YYYY, h:mm:ss a');
    return (
        <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Created:</Form.Label>
            <div style={{ color: 'black' }}>{label}</div>
        </Form.Group>
    )
}